import { Schema as S } from "effect";
const id = S.String.pipe(S.check(S.isMinLength(1)));
const text = S.Struct({ de: S.String, translations: S.Record(S.String, S.Struct({ text: S.String, sourceGerman: S.String })) });
const destination = S.Struct({ appointmentTypeId: id, calendarIds: S.optional(S.Array(id)) });
const question = S.Struct({ kind: S.Literal("question"), id, label: text, help: S.optional(text), includeInSummary: S.Boolean, answers: S.Array(S.Struct({ id, label: text, targetNodeId: id })) });
const booking = S.Struct({ kind: S.Literal("booking"), id, primary: S.Array(destination), alternatives: S.Array(destination) });
const reception = S.Struct({ kind: S.Literal("reception"), id, label: text });
/** Administrative single-choice graph with source-bound manual translations.
 * Layout is deliberately absent from executable semantics.
 * @since 1.1.8
 * @example S.decodeUnknownSync(BookingQuestionnaireSchema)(draft);
 */
export const BookingQuestionnaireSchema = S.Struct({ rootNodeId: id, offeredLanguages: S.Array(id), nodes: S.Array(S.Union([question, booking, reception])) });
/** Authored semantic graph decoded at ingress.
 * @since 1.1.8
 * @example const graph: BookingQuestionnaire = draft;
 */
export type BookingQuestionnaire = S.Schema.Type<typeof BookingQuestionnaireSchema>;
/** Transient ordered answer path; it contains neither a selected leaf nor routing authority.
 * @since 1.1.8
 * @example S.decodeUnknownSync(BookingAnswerPathSchema)([{ questionId: "q", answerId: "a" }]);
 */
export const BookingAnswerPathSchema = S.Array(S.Struct({ questionId: id, answerId: id }));
/** Typed transient answer path.
 * @since 1.1.8
 * @example const path: BookingAnswerPath = [];
 */
export type BookingAnswerPath = S.Schema.Type<typeof BookingAnswerPathSchema>;
